import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ENGAGE_PATHS, PATH_IDS, engageHref } from "@/content/engage";
import { ActionLink, Container, Eyebrow, Mono, Section, SectionTitle } from "@/components/site/primitives";

export const Participation = () => (
  <Section theme="t-ink" testid="home-participation" id="participation" className="grain overflow-hidden">
    <Container className="relative grid gap-12 py-24 lg:grid-cols-12 lg:py-32">
      <div className="lg:col-span-5">
        <Eyebrow index="05">Participation</Eyebrow>
        <SectionTitle className="mt-6">A company being formed around work that already exists.</SectionTitle>
        <p className="mt-6 leading-relaxed text-o-dim">
          Serious founding, technical, institutional, and commercial relationships are welcome. Each conversation begins from the part of the work it concerns.
        </p>
        <div className="mt-10">
          <ActionLink to="/engage?from=%2F" testid="home-engage-cta">Begin a conversation</ActionLink>
        </div>
      </div>
      <ul className="border-t border-o-line lg:col-span-7 lg:col-start-6">
        {PATH_IDS.map((id) => {
          const p = ENGAGE_PATHS[id];
          return (
            <li key={id}>
              <Link to={engageHref(id, "/")} data-testid={`home-engage-${id}`}
                className="group grid grid-cols-[auto_1fr_auto] items-center gap-5 border-b border-o-line px-2 py-6 transition-colors hover:bg-o-surface sm:gap-8">
                <Mono accent>{p.index}</Mono>
                <span>
                  <span className="block font-display text-xl font-bold sm:text-2xl">{p.title}</span>
                  <span className="mt-1 block text-sm text-o-dim">{p.forWhom}</span>
                </span>
                <ArrowRight className="h-5 w-5 text-o-dim transition-[transform,color] group-hover:translate-x-1 group-hover:text-o-accent" />
              </Link>
            </li>
          );
        })}
      </ul>
    </Container>
  </Section>
);
